import React from "react";
import { LuLogOut } from "react-icons/lu";

const Logout = ({ onLogout }) => {
  localStorage.clear();
  sessionStorage.clear();
  onLogout();
  return (
    <div className="flex items-center justify-center min-h-[40vh] px-4">
      <div className="ui-card-solid rounded-3xl p-6 sm:p-8 max-w-xs w-full flex flex-col items-center text-center">
        <span className="flex items-center justify-center w-12 h-12 rounded-2xl bg-gradient-to-br from-teal-500 to-cyan-500 text-white shadow-lg shadow-teal-500/30 mb-3">
          <LuLogOut size={22} />
        </span>
        <h2 className="text-lg font-extrabold text-gradient-teal">Logout</h2>
        <p className="text-sm text-main-subfont mt-1">
          You have been signed out securely.
        </p>
      </div>
    </div>
  );
};

export default Logout;
